import steps from './steps/stepsSlice';
import vehicleId from './vehicleId/vehicleIdSlice';
import listingType from './listingType/listingTypeSlice';
import paymentsInfo from './paymentsInfo/paymentsInfoSlice';

export default {
	steps,
	vehicleId,
	listingType,
	paymentsInfo
};
